import React from 'react';
import { Navigate } from 'react-router-dom';

const UnhandledDynamicLinkRoute: React.FC = () => <Navigate to="/" replace />;

export default UnhandledDynamicLinkRoute;
